function getBoostTAE() {
    return window.boostWidgetIntegration.TAEApp;
}
function getBoostTAEConfig() {
    return window.boostWidgetIntegration.TAEApp.config;
}
function addRegistryBlockListener(listener) {
    return window.boostWidgetIntegration.TAEApp.addRegistryBlockListener(listener);
}
function removeRegistryBlockListener(listener) {
    return window.boostWidgetIntegration.TAEApp.removeRegistryBlockListener(listener);
}
function onReady(handler) {
    return window.boostWidgetIntegration.TAEApp.onReady(handler);
}
export { addRegistryBlockListener, getBoostTAE, getBoostTAEConfig, onReady, removeRegistryBlockListener };
